import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/styles';

const CustomizedTooltip = styled(({ className, ...props }) => <Tooltip {...props} arrow classes={{ popper: className }} />)(
    ({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: '#e5e5e8'
        },
        [`& .${tooltipClasses.tooltip}`]: {
            color: '#212121',
            backgroundColor: '#e5e5e8',
            fontSize: 14
        }
    })
);

export default CustomizedTooltip;
